export const createPatientfields = [
  
  {
    name: "title",
    label: "Title",
    type: "select",
    required: true,
        placeholder: "Eg. Mr",

    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },

    options: [
      { value: "Mr", label: "Mr." },
      { value: "Ms", label: "Ms." },
    ],
  },
  {
    name: "name",
    label: "Full Name",
    type: "text",
        placeholder: "Eg. Ajay kumar",

    required: true,
    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },
  {
    name: "mobile",
    label: "Mobile Number",
    type: "mobile",
        placeholder: "Eg. 8855778854",

    required: true,
    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },
  {
    name: "email",
    label: "Email",
    type: "email",
        placeholder: "Eg. abcd@gmail.com",

    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },

  {
    name: "dob",
    label: "Date of Birth",
    type: "date",
    colSpan: {
      base: 6,
      sm: 6,
      md: 6,
      lg: 1,
    },
  },

  {
    name: "gender",
    label: "Gender",
    type: "select",
    required: true,
    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },

    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
      { value: "other", label: "Other" },
    ],
  },

  {
    name: "address",
    label: "Address",
    type: "textarea",
    required: true,
    colSpan: 6,
  },
];
